export const countriesData = [
  {
    code: 'cr',
    name: 'Costa Rica',
    dialCode: '+506',
    format: '(XXXX) XXXX',
    placeholder: '(8888) 8888',
    length: 8,
    padding: '50px',
  },
  // {
  //   code: 'in',
  //   name: 'India',
  //   dialCode: '+91',
  //   format: 'XXXXXXXXXX',
  //   placeholder: '9876543210',
  //   length: 10,
  //   padding: '40px'
  // },
  {
    code: 'us',
    name: 'United States',
    dialCode: '+1',
    format: '(XXX) XXX-XXXX',
    placeholder: '(123) 456-7890',
    length: 10,
    padding: '30px'
  },
  {
    code: 'es',
    name: 'Spain',
    dialCode: '+34',
    format: 'XXX XXX XXX',
    placeholder: '612 345 678',
    length: 9,
    padding: '40px'
  },
  // {
  //   code: 'pt',
  //   name: 'Portugal',
  //   dialCode: '+351',
  //   format: 'XXX XXX XXX',
  //   placeholder: '912 345 678',
  //   length: 9,
  //   padding: '50px'
  // }
];

export const getValidationForCountry = (country) => {
  return {
    pattern: new RegExp(`^\\d{${country.length}}$`),
    message: `${country.name} phone numbers must be ${country.length} digits`
  };
};

export const getCountryByCode = (code) =>
  countriesData.find(country => country.code === code);

export const DEFAULT_COUNTRY = countriesData[0];

export const statesByCountry = {
  cr: [
    { "code": "SJ", "name": "San José" },
    { "code": "AL", "name": "Alajuela" },
    { "code": "CA", "name": "Cartago" },
    { "code": "HE", "name": "Heredia" },
    { "code": "GU", "name": "Guanacaste" },
    { "code": "PU", "name": "Puntarenas" },
    { "code": "LI", "name": "Limón" }
  ],
  in: [
    { "code": "AP", "name": "Andhra Pradesh" },
    { "code": "AR", "name": "Arunachal Pradesh" },
    { "code": "AS", "name": "Assam" },
    { "code": "BR", "name": "Bihar" },
    { "code": "CG", "name": "Chhattisgarh" },
    { "code": "GA", "name": "Goa" },
    { "code": "GJ", "name": "Gujarat" },
    { "code": "HR", "name": "Haryana" },
    { "code": "HP", "name": "Himachal Pradesh" },
    { "code": "JH", "name": "Jharkhand" },
    { "code": "KA", "name": "Karnataka" },
    { "code": "KL", "name": "Kerala" },
    { "code": "MP", "name": "Madhya Pradesh" },
    { "code": "MH", "name": "Maharashtra" },
    { "code": "MN", "name": "Manipur" },
    { "code": "ML", "name": "Meghalaya" },
    { "code": "MZ", "name": "Mizoram" },
    { "code": "NL", "name": "Nagaland" },
    { "code": "OD", "name": "Odisha" },
    { "code": "PB", "name": "Punjab" },
    { "code": "RJ", "name": "Rajasthan" },
    { "code": "SK", "name": "Sikkim" },
    { "code": "TN", "name": "Tamil Nadu" },
    { "code": "TS", "name": "Telangana" },
    { "code": "TR", "name": "Tripura" },
    { "code": "UP", "name": "Uttar Pradesh" },
    { "code": "UK", "name": "Uttarakhand" },
    { "code": "WB", "name": "West Bengal" },
    { "code": "AN", "name": "Andaman and Nicobar Islands" },
    { "code": "CH", "name": "Chandigarh" },
    { "code": "DH", "name": "Dadra and Nagar Haveli and Daman and Diu" },
    { "code": "DL", "name": "Delhi" },
    { "code": "JK", "name": "Jammu and Kashmir" },
    { "code": "LA", "name": "Ladakh" },
    { "code": "LD", "name": "Lakshadweep" },
    { "code": "PY", "name": "Puducherry" }
  ],
  us: [
    { "code": "AL", "name": "Alabama" },
    { "code": "AK", "name": "Alaska" },
    { "code": "AZ", "name": "Arizona" },
    { "code": "AR", "name": "Arkansas" },
    { "code": "CA", "name": "California" },
    { "code": "CO", "name": "Colorado" },
    { "code": "CT", "name": "Connecticut" },
    { "code": "DE", "name": "Delaware" },
    { "code": "FL", "name": "Florida" },
    { "code": "GA", "name": "Georgia" },
    { "code": "HI", "name": "Hawaii" },
    { "code": "ID", "name": "Idaho" },
    { "code": "IL", "name": "Illinois" },
    { "code": "IN", "name": "Indiana" },
    { "code": "IA", "name": "Iowa" },
    { "code": "KS", "name": "Kansas" },
    { "code": "KY", "name": "Kentucky" },
    { "code": "LA", "name": "Louisiana" },
    { "code": "ME", "name": "Maine" },
    { "code": "MD", "name": "Maryland" },
    { "code": "MA", "name": "Massachusetts" },
    { "code": "MI", "name": "Michigan" },
    { "code": "MN", "name": "Minnesota" },
    { "code": "MS", "name": "Mississippi" },
    { "code": "MO", "name": "Missouri" },
    { "code": "MT", "name": "Montana" },
    { "code": "NE", "name": "Nebraska" },
    { "code": "NV", "name": "Nevada" },
    { "code": "NH", "name": "New Hampshire" },
    { "code": "NJ", "name": "New Jersey" },
    { "code": "NM", "name": "New Mexico" },
    { "code": "NY", "name": "New York" },
    { "code": "NC", "name": "North Carolina" },
    { "code": "ND", "name": "North Dakota" },
    { "code": "OH", "name": "Ohio" },
    { "code": "OK", "name": "Oklahoma" },
    { "code": "OR", "name": "Oregon" },
    { "code": "PA", "name": "Pennsylvania" },
    { "code": "RI", "name": "Rhode Island" },
    { "code": "SC", "name": "South Carolina" },
    { "code": "SD", "name": "South Dakota" },
    { "code": "TN", "name": "Tennessee" },
    { "code": "TX", "name": "Texas" },
    { "code": "UT", "name": "Utah" },
    { "code": "VT", "name": "Vermont" },
    { "code": "VA", "name": "Virginia" },
    { "code": "WA", "name": "Washington" },
    { "code": "WV", "name": "West Virginia" },
    { "code": "WI", "name": "Wisconsin" },
    { "code": "WY", "name": "Wyoming" },
  ],
  es: [
    { "code": "C", "name": "A Coruña" },
    { "code": "AB", "name": "Albacete" },
    { "code": "A", "name": "Alicante" },
    { "code": "AL", "name": "Almería" },
    { "code": "VI", "name": "Álava" },
    { "code": "O", "name": "Asturias" },
    { "code": "AV", "name": "Ávila" },
    { "code": "BA", "name": "Badajoz" },
    { "code": "B", "name": "Barcelona" },
    { "code": "BI", "name": "Bizkaia" },
    { "code": "BU", "name": "Burgos" },
    { "code": "CC", "name": "Cáceres" },
    { "code": "CA", "name": "Cádiz" },
    { "code": "S", "name": "Cantabria" },
    { "code": "CS", "name": "Castellón" },
    { "code": "CR", "name": "Ciudad Real" },
    { "code": "CO", "name": "Córdoba" },
    { "code": "CU", "name": "Cuenca" },
    { "code": "GI", "name": "Girona" },
    { "code": "SS", "name": "Gipuzkoa" },
    { "code": "GR", "name": "Granada" },
    { "code": "GU", "name": "Guadalajara" },
    { "code": "H", "name": "Huelva" },
    { "code": "HU", "name": "Huesca" },
    { "code": "PM", "name": "Illes Balears" },
    { "code": "J", "name": "Jaén" },
    { "code": "LO", "name": "La Rioja" },
    { "code": "GC", "name": "Las Palmas" },
    { "code": "LE", "name": "León" },
    { "code": "L", "name": "Lleida" },
    { "code": "LU", "name": "Lugo" },
    { "code": "M", "name": "Madrid" },
    { "code": "MA", "name": "Málaga" },
    { "code": "MU", "name": "Murcia" },
    { "code": "NA", "name": "Navarra" },
    { "code": "OR", "name": "Ourense" },
    { "code": "P", "name": "Palencia" },
    { "code": "PO", "name": "Pontevedra" },
    { "code": "SA", "name": "Salamanca" },
    { "code": "TF", "name": "Santa Cruz de Tenerife" },
    { "code": "SG", "name": "Segovia" },
    { "code": "SE", "name": "Sevilla" },
    { "code": "SO", "name": "Soria" },
    { "code": "T", "name": "Tarragona" },
    { "code": "TE", "name": "Teruel" },
    { "code": "TO", "name": "Toledo" },
    { "code": "V", "name": "Valencia" },
    { "code": "VA", "name": "Valladolid" },
    { "code": "ZA", "name": "Zamora" },
    { "code": "Z", "name": "Zaragoza" },
  ],
  pt: [
    { "code": "LIS", "name": "Lisbon" },
    { "code": "POR", "name": "Porto" },
    { "code": "BRG", "name": "Braga" },
    { "code": "SET", "name": "Setúbal" },
    { "code": "AVR", "name": "Aveiro" },
    { "code": "COI", "name": "Coimbra" },
    { "code": "FAR", "name": "Faro" },
    { "code": "EVO", "name": "Évora" },
    { "code": "GUI", "name": "Guimarães" },
    { "code": "VSE", "name": "Viseu" },
    { "code": "LEI", "name": "Leiria" },
    { "code": "FUN", "name": "Funchal" },
    { "code": "PDL", "name": "Ponta Delgada" },
    { "code": "VNG", "name": "Vila Nova de Gaia" },
    { "code": "SIN", "name": "Sintra" },
    { "code": "AMA", "name": "Amadora" },
    { "code": "ALM", "name": "Almada" },
    { "code": "BAR", "name": "Barreiro" },
    { "code": "MAT", "name": "Matosinhos" },
    { "code": "VDC", "name": "Viana do Castelo" }
  ]
};
// cr:spanish:[
//     { code: 'SJ', name: 'San José' },
//     { code: 'AL', name: 'Alajuela' },
//     { code: 'HE', name: 'Heredia' },
//     { code: 'CA', name: 'Cartago' },
//     { code: 'GU', name: 'Guanacaste' },
//     { code: 'PU', name: 'Puntarenas' },
//     { code: 'LI', name: 'Limón' }
//   ],
//es:spanish: [

// { "code": "AN", "name": "Andalucía" },
// { "code": "AR", "name": "Aragón" },
// { "code": "AS", "name": "Asturias" },
// { "code": "IB", "name": "Islas Baleares" },
// { "code": "CN", "name": "Canarias" },
// { "code": "CB", "name": "Cantabria" },
// { "code": "CL", "name": "Castilla y León" },
// { "code": "CM", "name": "Castilla-La Mancha" },
// { "code": "CT", "name": "Cataluña" },
// { "code": "EX", "name": "Extremadura" },
// { "code": "GA", "name": "Galicia" },
// { "code": "MD", "name": "Madrid" },
// { "code": "MC", "name": "Murcia" },
// { "code": "NC", "name": "Navarra" },
// { "code": "PV", "name": "País Vasco" },
// { "code": "RI", "name": "La Rioja" },
// { "code": "VC", "name": "Comunidad Valenciana" },
// { "code": "CE", "name": "Ceuta" },
// { "code": "ML", "name": "Melilla" }
// ],
// pt: spanish:
// [
//   { "code": "LIS", "name": "Lisboa" },
//   { "code": "POR", "name": "Oporto" },
//   { "code": "BRG", "name": "Braga" },
//   { "code": "SET", "name": "Setúbal" },
//   { "code": "AVR", "name": "Aveiro" },
//   { "code": "COI", "name": "Coímbra" },
//   { "code": "FAR", "name": "Faro" },
//   { "code": "EVO", "name": "Évora" },
//   { "code": "GUI", "name": "Guimarães" },
//   { "code": "VSE", "name": "Viseu" },
//   { "code": "LEI", "name": "Leiría" },
//   { "code": "FUN", "name": "Funchal" },
//   { "code": "PDL", "name": "Ponta Delgada" },
//   { "code": "VNG", "name": "Vila Nova de Gaia" },
//   { "code": "SIN", "name": "Sintra" },
//   { "code": "AMA", "name": "Amadora" },
//   { "code": "ALM", "name": "Almada" },
//   { "code": "BAR", "name": "Barreiro" },
//   { "code": "MAT", "name": "Matosinhos" },
//   { "code": "VDC", "name": "Viana do Castelo" }
// ]

// portugese:[
//   { "code": "LIS", "name": "Lisboa" },
//   { "code": "POR", "name": "Porto" },
//   { "code": "BRG", "name": "Braga" },
//   { "code": "SET", "name": "Setúbal" },
//   { "code": "AVR", "name": "Aveiro" },
//   { "code": "COI", "name": "Coimbra" },
//   { "code": "FAR", "name": "Faro" },
//   { "code": "EVO", "name": "Évora" },
//   { "code": "GUI", "name": "Guimarães" },
//   { "code": "VSE", "name": "Viseu" },
//   { "code": "LEI", "name": "Leiria" },
//   { "code": "FUN", "name": "Funchal" },
//   { "code": "PDL", "name": "Ponta Delgada" },
//   { "code": "VNG", "name": "Vila Nova de Gaia" },
//   { "code": "SIN", "name": "Sintra" },
//   { "code": "AMA", "name": "Amadora" },
//   { "code": "ALM", "name": "Almada" },
//   { "code": "BAR", "name": "Barreiro" },
//   { "code": "MAT", "name": "Matosinhos" },
//   { "code": "VDC", "name": "Viana do Castelo" }
// ]

